var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 642.7 250",
    style: {
      enableBackground: "new 0 0 642.7 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#803300}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2764",
    className: "st0",
    d: "m642.6 249.9-17.9-17.5-.4-214.7L642.6.1v249.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect1873",
    style: {
      fill: "#f60"
    },
    d: "M17.6 17.8h607.1v214.8H17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1875",
    d: "m0 0 642.7.1-18.2 17.6-606.7.2L0 0z",
    style: {
      fill: "#fca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2762",
    d: "m.1 249.9 642.6.1-18-17.6H17.6L.1 249.9z",
    style: {
      fill: "#520"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3651",
    d: "M17.8 232.2 0 249.9V0l17.7 17.7.1 214.5z",
    style: {
      fill: "#f95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4580"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "text4574",
    className: "st0",
    d: "M86 69h52.2l27.2 47.2L191.7 69h51.7l-47.7 74.3 52.2 79.1h-53.2l-30.2-49.3-30.3 49.3h-53l52.9-79.9L86 69zm176.6 0h62.3l24.1 93.3L373 69h62v153.3h-38.7V105.4l-30 116.9h-35l-29.9-116.9v116.9h-38.8V69zm202.6 0h47.4v115.6h74v37.8H465.2V69z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "text4570",
    d: "M75.7 52.5h52.2l27.2 47.2 26.4-47.2h51.7l-47.7 74.3 52.2 79.1h-53.2l-30.2-49.3-30.3 49.3H70.9l52.9-79.9-48.1-73.5zm176.6 0h62.3l24.1 93.3 24-93.3h62.1v153.3h-38.7V88.9l-30 116.9h-35l-30-116.9v116.9h-38.8V52.5zm202.6 0h47.4v115.6h74v37.8H454.9V52.5z",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.9e905bf63eb284ea5ba8c0786c56edae.svg";
export { ForwardRef as ReactComponent };